module.exports = __webpack_public_path__ + "img/365.1dfdd2fa.png";